import { Link } from "react-router-dom";
import { signOutUser } from "../../firebase/firebase-app";

import useScrollDirection from "../hooks/useScrollDirection";

import Nav from "./Nav";
import OpenModalButton from "../helper-components/OpenModalButton";
import SignUpOptions from "../sign_in_and_up/SignUpOptions";
import SignInOptions from "../sign_in_and_up/SignInOptions";
import LogoWithoutText from "../helper-components/LogoWithoutText";
import Searchbar from "./Searchbar";
import { useContext } from "react";
import UserContext from "../../UserContext";

export default function Header() {
  const scrollDirection = useScrollDirection();
  const { user, isAnonymous } = useContext(UserContext);

  return (
    <header
      className={`sticky ${
        scrollDirection === "down" ? "-top-[57px]" : "top-0"
      } z-10 min-h-[57px] bg-white px-6 border-b border-b-subtle-white flex items-center transition-all duration-250`}
    >
      <div className="logo-h w-full grow flex items-left w-1/2 gap-2">
        <Link to="/">
          <LogoWithoutText />
        </Link>

        <Searchbar />
      </div>

      {user || isAnonymous ? (
        <Nav user={user} onSignOut={signOutUser} />
      ) : (
        <div className="signup-row">
          <OpenModalButton
            element={<SignUpOptions />}
            className="bg-green hover:bg-dark-green text-white py-[2px] px-[7px] rounded-md text-sm"
          >
            Sign up
          </OpenModalButton>

          <OpenModalButton
            element={<SignInOptions />}
            className="text-grey hover:text-lightblack text-[15px] ml-4"
          >
            Sign In
          </OpenModalButton>
        </div>
      )}
    </header>
  );
}
